import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Suspense } from "react";

import Layout from "../views/layout";
import PageLoader from "../views/components/Common/PageLoader";
import { useAppContext } from "../contexts/useStorageContext";
import {
  AdditiveAlgorithmsPage,
  ChangeLogsPage,
  Companies,
  CropTypes,
  DairyRationsPage,
  DocumentationPage,
  FarmManagementPage,
  FeedersPage,
  FileDownload,
  ForgotPassword,
  GasAnalysis,
  Home,
  IntakeManagementPage,
  ISCscannerPage,
  AskLogsPage,
  ApiLogsPage,
  KnowledgePoolPage,
  Login,
  OnboardingGuidesPage,
  PredictionModelsPage,
  PrivacyPolicy,
  ResearchSchedulingPage,
  SampleSource,
  Settings,
  Signup,
  TermsAndConditions,
  TrainingReportDetailPage,
  TrainingReportsPage,
  Trainings,
  Users,
} from "./lazyPages";
import RedirectToLogin from "./RedirectToLogin";

export default function Root() {
  const { state, isHydrated } = useAppContext();

  if (!isHydrated) {
    return <PageLoader />;
  }

  return (
    <BrowserRouter>
      {state.loggedInUserInfo?.email ? (
        <Suspense fallback={<PageLoader />}>
          <Routes key={JSON.stringify(state.loggedInUserInfo)}>
            <Route path="/" element={<Layout />}>
              <Route path="dashboard" element={<Home />} />
              <Route path="farm-management" element={<FarmManagementPage />} />
              <Route
                path="intake-management"
                element={<IntakeManagementPage />}
              />
              <Route path="companies" element={<Companies />} />
              <Route path="sample-sources" element={<SampleSource />} />
              <Route path="gas-analysis" element={<GasAnalysis />} />
              <Route path="crop-types" element={<CropTypes />} />
              <Route
                path="prediction-model"
                element={<PredictionModelsPage />}
              />
              <Route path="documentation" element={<DocumentationPage />} />
              <Route path="rd-schedule" element={<ResearchSchedulingPage />} />
              <Route
                path="additive-algorithms"
                element={<AdditiveAlgorithmsPage />}
              />
              <Route path="feeders" element={<FeedersPage />} />
              <Route
                path="training-report/:id"
                element={<TrainingReportDetailPage />}
              />
              <Route path="training-report" element={<TrainingReportsPage />} />
              <Route path="dairy-ration" element={<DairyRationsPage />} />
              <Route path="nasem" element={<Navigate to="/dairy-ration" replace />} />
              <Route
                path="onboarding-guides"
                element={<OnboardingGuidesPage />}
              />
              <Route path="change-logs" element={<ChangeLogsPage />} />
              <Route path="knowledge-pool" element={<KnowledgePoolPage />} />
              <Route path="ask-logs" element={<AskLogsPage />} />
              <Route path="api-logs" element={<ApiLogsPage />} />
              <Route path="isc-nir-scanner" element={<ISCscannerPage />} />
              <Route path="users" element={<Users />} />
              <Route path="trainings" element={<Trainings />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="settings" element={<Settings />} />
              <Route path="file-download" element={<FileDownload />} />
            </Route>
          </Routes>
        </Suspense>
      ) : (
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Signup />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="*" element={<RedirectToLogin />} />
          </Routes>
        </Suspense>
      )}
    </BrowserRouter>
  );
}
